import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { Company } from '../../../models/company';

@Component({
  selector: 'app-client-dashboard',
  templateUrl: './client-dashboard.component.html',
  styleUrls: ['./client-dashboard.component.scss']
})
export class ClientDashboardComponent implements OnInit {
  company: Company = undefined;
    loading: boolean = false;

  user;
  companyName: string = '';
  messageBody: string = '';
  messageTitle: string = '';
  company_Id;

  constructor(private authService: AuthService, private snotifyService: SnotifyService, public router: Router, public companyService: CompanyService) {
    this.user = this.authService.currentUser.value;
    this.company_Id = this.user.companyId;
    //console.log(this.company_Id);

  }

  ngOnInit(): void {
    this.loading = true;

    if (this.company_Id != null) {
      this.companyService.get(this.company_Id).then((c) => {
        this.company = c;
        this.companyName = c.name;
        this.messageTitle = c.messageTitle;
        this.messageBody = c.messageBody;
      }, (err) => {
        this.snotifyService.error("Error loading company details");
        this.loading = false;
        this.company_Id = undefined;

      });
    }
  }

  
  viewEquipment() {
    this.router.navigate(['admin/assets/'], { queryParams: { id: this.company_Id } });
  }
}
